import ClearingAPI from '@shared/api';

export const {
    users: { getclientDashboard: getClientDashboard, authenticateUser, fetchStockQuotes, fetchFullHistory },
    securities: { addFavouriteStock, removeFavouriteStock, getFavourite },
} = ClearingAPI.settings;
